import { RootState } from 'editor/src/store/index';

// the buyer's session override wins; otherwise fall back to the host-provided default
const getResolvedAllowRotate = (state: RootState) =>
  state.gangSheet.allowRotate ?? state.hostSettings.gangSheet?.allowRotate;

export default getResolvedAllowRotate;
